<div
  fxLayout
  fxLayoutGap="12px"
  fxLayoutAlign="start center"
  class="heroitem__container"
  [class.heroitem__indent]="indent">
  <ng-container *ngIf="!indent">
    <sbnb-icon icon="check" class="text-grass-darker" *ngIf="context === 'positive'"></sbnb-icon>
    <sbnb-icon icon="information" *ngIf="context === 'neutral'"></sbnb-icon>
    <sbnb-icon icon="delete" *ngIf="context === 'negative'"></sbnb-icon>
  </ng-container>
  <div [ngClass]="{ text__small: indent }">
    <ng-content></ng-content>
  </div>
</div>
